export default __webpack_public_path__ + "src/assets/icons/plus_circle_icon.png";